import { emulatorScreen, mobileScreen } from "../../../../utils/styleUtils";

const styles = (theme) => ({
  verticalLinesContainer: {
    position: "absolute",
    top: "-52px",
    left: "225px",
    [emulatorScreen(theme)]: {
      top: "-35px",
      left: "150px",
    },
    [mobileScreen(theme)]: {
      top: "-25px",
      left: "100px",
    },
  },

  graphLines: {
    borderLeft: "5px solid #565656",
    borderBottom: "5px solid #565656",
    height: "330px",
    width: "460px",
    position: "relative",
    [emulatorScreen(theme)]: {
      width: "290px",
      height: "210px",
      borderWidth: "3px",
    },
    [mobileScreen(theme)]: {
      width: "200px",
      height: "150px",
      borderWidth: "3px",
    },
  },

  graphYLable: {
    height: "18px",
    position: "absolute",
    top: "7px",
    left: "-90px",
    [emulatorScreen(theme)]: {
      height: "12px",
      left: "-60px",
    },
    [mobileScreen(theme)]: {
      height: "10px",
      left: "-50px",
    },
  },

  graphXLable: {
    height: "18px",
    position: "absolute",
    bottom: "-35px",
    right: "5px",
    [emulatorScreen(theme)]: {
      height: "12px",
      bottom: "-25px",
    },
    [mobileScreen(theme)]: {
      height: "10px",
      bottom: "-22px",
    },
  },

  dragLineMessage: {
    height: "130px",
    position: "absolute",
    right: "-20px",
    top: "80px",
    [emulatorScreen(theme)]: {
      height: "90px",
      right: "-25px",
      top: "50px",
    },
    [mobileScreen(theme)]: {
      top: "25px",
      right: "-25px",
      height: "75px",
    },
  },

  questionMark: {
    width: "150px",
    [emulatorScreen(theme)]: {
      width: "95px",
    },
    [mobileScreen(theme)]: {
      width: "85px",
    },
  },

  arrows: {
    position: "absolute",
    height: "30px",
    top: "185px",
    left: "-50px",
    [emulatorScreen(theme)]: {
      top: "117px",
      left: "12px",
      height: "18px",
    },
    [mobileScreen(theme)]: {
      top: "84px",
      left: "8px",
      height: "10px",
    },
  },

  defaultLine: {
    transform: "rotate(-45deg)",
    position: "absolute",
    height: "400px",
    width: "8px",
    backgroundColor: "#003e4c",
    borderRadius: "5px",
    [emulatorScreen(theme)]: {
      height: "260px",
      width: "6px",
    },
    [mobileScreen(theme)]: {
      height: "190px",
      width: "6px",
    },
  },

  correctLine: {
    transform: "rotate(-45deg)",
    position: "absolute",
    height: "400px",
    width: "8px",
    borderRadius: "5px",
    [emulatorScreen(theme)]: {
      height: "260px",
      width: "6px",
    },
    [mobileScreen(theme)]: {
      height: "190px",
      width: "6px",
    },
  },

  dragableLine: {
    display: "flex",
    justifyContent: "center",
    height: "400px",
    width: "6px",
    position: "relative",
    borderRadius: "5px",
    transform: "rotate(-45deg)",
    [emulatorScreen(theme)]: {
      height: "260px",
      width: "6px",
    },
    [mobileScreen(theme)]: {
      height: "190px",
      width: "6px",
    },
  },

  dragableLineContainer: {
    display: "flex",
    justifyContent: "center",
    width: "6px",
    position: "relative",
    borderRadius: "5px",
    transform: "rotate(-45deg)",
    top: "28px",
    left: "-68px",
    height: "0",
    position: "absolute",
    // [emulatorScreen(theme)]: {
    //   height: "260px",
    //   width: "5px",
    // },
    // [mobileScreen(theme)]: {
    //   height: "190px",
    //   width: "4px"
    // },
  },

  fadedDot: {
    position: "absolute",
    transform: "rotate(45deg)",
    border: "5px solid #003E4C",
    borderRadius: "50%",
    padding: "10px",
    backgroundColor: "#003E4C",
    top: "120px",
    color: "blue",
    [emulatorScreen(theme)]: {
      padding: "7px",
      borderWidth: "4px",
    },
    [mobileScreen(theme)]: {
      padding: "7px",
      borderWidth: "4px",
    },
  },

  correctDot: {
    position: "absolute",
    transform: "rotate(45deg)",
    border: "5px solid #003e4c",
    borderRadius: "50%",
    padding: "10px",
    backgroundColor: "#CACDCE",
    color: "blue",
    zindex: 100,
    // border: "5px solid",
    [emulatorScreen(theme)]: {
      padding: "7px",
      border: "4px solid #003e4c",
    },
    [mobileScreen(theme)]: {
      padding: "7px",
      border: "4px solid #003e4c",
    },
  },

  draggableDot: {
    transform: "rotate(45deg)",
    borderRadius: "50%",
    padding: "10px",
    color: "blue",
    border: "5px solid",
    [emulatorScreen(theme)]: {
      padding: "7px",
      border: "4px solid",
    },
    [mobileScreen(theme)]: {
      padding: "7px",
      border: "4px solid",
    },
  },

  internationalContainerMajor: {
    justifyContent: "center",
    position: "relative",
    display: "flex",

    [emulatorScreen(theme)]: {
      justifyContent: "start",
    },
    [mobileScreen(theme)]: {
      justifyContent: "start",
    },
  },

  internationalContainerChild: {
    position: "relative",
    display: "flex",
    height: 400,
    width: 400,
    [emulatorScreen(theme)]: {
      height: 270,
      width: 270,
    },
    [mobileScreen(theme)]: {
      height: 270,
      width: 270,
    },
  },

  qdWhite: {
    height: "27%",
    top: 195,
    position: "absolute",
    marginLeft: "94%",
    paddingTop: "15%",
    [emulatorScreen(theme)]: {
      top: 133,
    },
    [mobileScreen(theme)]: {
      top: 133,
    },
  },

  qoWhite: {
    height: "27%",
    top: 195,
    position: "absolute",
    left: 286,
    paddingTop: "15%",
    zIndex: 1,
    [emulatorScreen(theme)]: {
      top: 132,
      left: 193,
    },
    [mobileScreen(theme)]: {
      top: 132,
      left: 193,
    },
  },

  qsWhite: {
    height: "27%",
    top: 195,
    position: "absolute",
    marginLeft: "50%",
    paddingTop: "15%",
    zIndex: 1,
    [emulatorScreen(theme)]: {
      top: 132,
      marginLeft: "49%",
    },
    [mobileScreen(theme)]: {
      top: 132,
      marginLeft: "49%",
    },
  },

  poWhite: {
    position: "absolute",
    top: 179,
    width: "55%",
    left: 77,
    [emulatorScreen(theme)]: {
      top: 106,
      height: "16%",
      left: 51,
    },
    [mobileScreen(theme)]: {
      top: 106,
      left: 51,
    },
  },
  HoriWhiteHalf1: {
    height: '1.2%',
    top: 126,
    left: 111,
    position: "absolute",
    [emulatorScreen(theme)]: {
      top: 84,
      left: 75,
    },
    [mobileScreen(theme)]: {
      top: 80,
      right: 60,
    },
  },

  HoriWhiteHalf22: {
    height: '1.2%',
    top: 189,
    left: 207,
    position: "absolute",
    [emulatorScreen(theme)]: {
      top: 126,
      left: 143,
    },
    [mobileScreen(theme)]: {
      top: 126.2,
      right: 60,
    },
  },

  vertWhiteHalf1: {
    height: "15%",
    top: 130,
    left: 203,
    position: "absolute",
    [emulatorScreen(theme)]: {
      top: 80,
      left: 133.89,
    },
    [mobileScreen(theme)]: {
      top: 87,
      right: 60,
    },
  },

  verticleBlueHalf1: {
    height: "15%",
    top: 130,
    right: "43.5%",
    position: "absolute",
    [emulatorScreen(theme)]: {
      height: "17%",
      top: 80,
      left: 132.89,
      right: "0%",
    },
    [mobileScreen(theme)]: {
      height: "17%",
      top: 87,
      left: 132.7,
      right: "0%",
    },
  },

  vertRedHalf1: {
    height: "17%",
    top: 130,
    right: 183.65,
    position: "absolute",
    [emulatorScreen(theme)]: {
      // top: 133,
      top: 80,
      left: 139.89,
      // right: 60,
    },
    [mobileScreen(theme)]: {
      top: 87,
      right: "24.6%",
    },
  },

  verticleGreenHalf1: {
    height: "17%",
    top: 130,
    right: 183.65,
    position: "absolute",
    [emulatorScreen(theme)]: {
      top: 80,
      left: 139.89,
    },
    [mobileScreen(theme)]: {
      top: 87,
      right: 65.65,
    },
  },

  vertWhiteHalf2: {
    height: "15%",
    top: 193,
    left: 203,
    position: "absolute",
    zIndex: 1,
    [emulatorScreen(theme)]: {
      top: 133,
      left: 134,
    },
    [mobileScreen(theme)]: {
      top: 133,
      left: 134,
    },
  },

  verticleBlueHalf2: {
    height: "15%",
    top: 193,
    right: "43.49%",
    position: "absolute",
    [emulatorScreen(theme)]: {
      height: "17%",
      top: 129,
      right: 119,
    },
    [mobileScreen(theme)]: {
      height: "17%",
      top: 130,
      left: 133,
      right: "0%",
    },
  },

  vertRedHalf2: {
    height: "17%",
    top: 193,
    right: 183.65,
    position: "absolute",
    [emulatorScreen(theme)]: {
      // top: 133,
      top: 129,
      right: 127,
      // right: 60,
    },
    [mobileScreen(theme)]: {
      top: 128,
      left: 140,
    },
  },

  verticleGreenHalf2: {
    height: "17%",
    top: 193,
    right: 183.65,
    position: "absolute",
    [emulatorScreen(theme)]: {
      top: 126,
      right: 66.5,
    },
    [mobileScreen(theme)]: {
      top: 126,
      left: 140,
    },
  },

  vertWhiteHalf: {
    height: "15%",
    top: 195,
    right: 88,
    position: "absolute",
    zIndex: 1,
    [emulatorScreen(theme)]: {
      top: 133,
      right: 60,
    },
    [mobileScreen(theme)]: {
      top: 133,
      right: 60,
    },
  },

  HoriWhiteHalf25: {
    height: '1.2%',
    top: 189,
    left: 111,
    position: "absolute",
    [emulatorScreen(theme)]: {
      top: 125.5,
      left: 75,
    },
    [mobileScreen(theme)]: {
      top: 126,
      right: 60,
    },
  },

  // horizontalBlue: {
  //   position: "absolute",
  //   top: 179,
  //   width: "46%",
  //   left: 111,
  //   [emulatorScreen(theme)]: {
  //     top: 119.5,
  //     width: "46.5%",
  //     left: 75,
  //   },
  //   [mobileScreen(theme)]: {
  //     top: 120.15,
  //     width: "46.5%",
  //     left: 75,
  //   },
  // },

  verticle2HalfBlue: {
    height: "17.7%",
    top: 200,
    position: "absolute",
    marginLeft: "50.15%",
    paddingTop: "15%",
    [emulatorScreen(theme)]: {
      height: "17%",
      top: 136,
      marginLeft: "49.20%",
    },
    [mobileScreen(theme)]: {
      height: "17%",
      top: 136,
      marginLeft: "49.15%",
    },
  },

  verticleBlueHalf: {
    height: "15%",
    top: 195,
    right: "21.95%",
    position: "absolute",
    [emulatorScreen(theme)]: {
      height: "17%",
      top: 130,
      left: 193.5,
      right: "0%",
    },
    [mobileScreen(theme)]: {
      height: "17%",
      top: 130,
      left: 193.5,
      right: "0%",
    },
  },

  verticle1HalfBlue: {
    height: "18%",
    top: 261,
    position: "absolute",
    left: 287,
    [emulatorScreen(theme)]: {
      top: 175,
      left: 193,
    },
    [mobileScreen(theme)]: {
      top: 175,
      left: 193,
    },
  },

  vertRedHalf: {
    height: "17%",
    top: 193,
    right: 97.65,
    position: "absolute",
    [emulatorScreen(theme)]: {
      // top: 133,
      top: 130,
      right: 66.65,
      // right: 60,
    },
    [mobileScreen(theme)]: {
      top: 128,
      right: "24.6%",
    },
  },

  verticle3HalfBlue: {
    height: "27%",
    top: 195,
    position: "absolute",
    marginLeft: "94%",
    paddingTop: "15%",
    [emulatorScreen(theme)]: {
      height: "26%",
      top: 135,
    },
    [mobileScreen(theme)]: {
      height: "26%",
      top: 135,
    },
  },

  verticle2HalfRed: {
    position: "absolute",
    top: 260,
    width: 4.5,
    left: 297.5,
    [emulatorScreen(theme)]: {
      height: "18%",
      top: 176,
      left: 200,
    },
    [mobileScreen(theme)]: {
      height: "18%",
      top: 176,
      left: 200,
    },
  },

  verticle3HalfRed: {
    height: "17%",
    top: 201,
    position: "absolute",
    marginLeft: "97%",
    paddingTop: "15%",
    [emulatorScreen(theme)]: {
      top: 136,
      marginLeft: "96.85%",
    },
    [mobileScreen(theme)]: {
      top: 136,
      marginLeft: "96.85%",
    },
  },

  verticle1HalfRed: {
    height: 69,
    top: 200,
    position: "absolute",
    marginLeft: "53%",
    paddingTop: "15%",
    [emulatorScreen(theme)]: {
      height: 46,
      top: 136,
      marginLeft: "52%",
    },
    [mobileScreen(theme)]: {
      height: 46,
      top: 136,
      marginLeft: "52%",
    },
  },

  verticleGreenHalf: {
    height: "17%",
    top: 193,
    right: 97.65,
    position: "absolute",
    [emulatorScreen(theme)]: {
      top: 126,
      right: 66.5,
    },
    [mobileScreen(theme)]: {
      top: 126,
      right: 65.65,
    },
  },

  horizontalRedLine: {
    height: "1%",
    position: "absolute",
    top: 189,
    width: "46%",
    left: 111,
    [emulatorScreen(theme)]: {
      top: 127,
      left: 75,
    },
    [mobileScreen(theme)]: {
      top: 127,
      left: 75,
    },
  },

  // horizontalGreenLine: {
  //   position: "absolute",
  //   top: 188,
  //   width: "48%",
  //   left: 111,
  //   [emulatorScreen(theme)]: {
  //     top: 126,
  //     left: 75,
  //   },
  //   [mobileScreen(theme)]: {
  //     top: 127,
  //     left: 75,
  //   },
  // },

  shape1Major: {
    width: 373,
    overflow: "hidden",
    top: 41.5,
    left: 116.5,
    position: "absolute",
    zIndex: 3,
    height: 145,
    clipPath: "polygon(0 7px, 49.1% 100%, 100% 4px)",
    shapeOutside: "polygon(0 7px, 49.1% 100%, 100% 4px)",
    [emulatorScreen(theme)]: {
      clipPath: "polygon(0% 4%, 50% 100%, 100% 3%)",
      width: 267,
      top: 21.5,
      left: 70,
      height: 104,
    },
    [mobileScreen(theme)]: {
      width: 267,
      top: 21.5,
      left: 70,
      height: 104,
    },
  },

  shape1: {
    height: 142,
    width: 373,
    marginTop: 4,
    [emulatorScreen(theme)]: {
      height: "100%",
      width: "100%",
      // marginTop: 4,
    },
    [mobileScreen(theme)]: {
      height: 142,
      width: 373,
      marginTop: 4,
    },
  },

  shape2Major: {
    width: 101,
    overflow: "hidden",
    top: 44.5,
    left: 111,
    position: "absolute",
    zIndex: 2,
    // height: 75,
    [emulatorScreen(theme)]: {
      width: 74,
      top: 29.5,
      left: 75,
      height: 55,
    },
    [mobileScreen(theme)]: {
      width: 64,
      top: 30.5,
      left: 75,
      height: 50,
    },
  },

  shape2: {
    height: 75,
    width: '100%',
    marginTop: 7,
    [emulatorScreen(theme)]: {
      height: "100%",
      width: "100%",
      marginTop: 6,
    },
    [mobileScreen(theme)]: {
      // height: 92.5,
      // width: 123.5,
      // marginTop: 4,
      height: "100%",
      width: "100%",
      marginTop: 4,
    },
  },

  shape21Major: {
    width: 101,
    overflow: "hidden",
    top: 123,
    left: 111,
    position: "absolute",
    zIndex: 2,
    [emulatorScreen(theme)]: {
      width: 65,
      top: 81,
      left: 75,
      height: 45,
    },
    [mobileScreen(theme)]: {
      width: 65,
      top: 79,
      left: 75,
      height: 47,
    },
  },

  shape21: {
    height: 59,
    width: '100%',
    marginTop: 7,
    [emulatorScreen(theme)]: {
      height: "100%",
      width: "100%",
      marginTop: 6,
    },
    [mobileScreen(theme)]: {
      height: "100%",
      width: "100%",
      marginTop: 4,
    },
  },

  shape22Major: {
    width: 78,
    overflow: "hidden",
    top: 126,
    right: 106,
    position: "absolute",
    zIndex: 2,
    [emulatorScreen(theme)]: {
      width: 61,
      top: 80.5,
      left: 143,
      height: 45.5,
    },
    [mobileScreen(theme)]: {
      width: 61,
      top: 80.5,
      left: 143,
      height: 45.5,
    },
  },

  shape22: {
    height: 57,
    width: '100%',
    marginTop: 6,
    [emulatorScreen(theme)]: {
      height: "100%",
      width: "100%",
      marginTop: 6,
    },
    [mobileScreen(theme)]: {
      height: 92.5,
      width: 123.5,
      marginTop: 4,
    },
  },

  shape5Major: {
    width: 101,
    height: 63,
    overflow: "hidden",
    top: 193,
    left: 111,
    position: "absolute",
    zIndex: 3,
    [emulatorScreen(theme)]: {
      width: 65,
      height: 44,
      top: 129,
      left: 75,
    },
    [mobileScreen(theme)]: {
      width: 65,
      height: 43,
      top: 129.2,
      left: 75,
    },
  },

  shape5: {
    height: 62.5,
    width: '100%',
    // clipPath: "polygon(0 0, 100% 0, 54.85% 100%, 0% 100%)",
    // shapeOutside: "polygon(0 0, 100% 0, 54.85% 100%, 0% 100%)",
    clipPath: "inset(0 0 0 0)",
    shapeOutside: "inset(0 0 0 0)",
    [emulatorScreen(theme)]: {
      height: 44,
      width: 123,
      clipPath: "polygon(0 0, 100% 0, 52.85% 100%, 0% 100%)",
      shapeOutside: "polygon(0 0, 100% 0, 52.85% 100%, 0% 100%)",
    },
    [mobileScreen(theme)]: {
      height: 43,
      width: 123,
      clipPath: "polygon(0 0, 100% 0, 53.85% 100%, 0% 100%)",
      shapeOutside: "polygon(0 0, 100% 0, 53.85% 100%, 0% 100%)",
    },
  },

  shape51Major: {
    width: 75,
    height: 56,
    overflow: "hidden",
    top: 193,
    right: 109,
    position: "absolute",
    zIndex: 3,
    [emulatorScreen(theme)]: {
      width: 55,
      height: 41,
      top: 129,
      left: 143,
    },
    [mobileScreen(theme)]: {
      width: 55,
      height: 40,
      top: 129.5,
      left: 143,
    },
  },

  shape51: {
    height: '100%',
    width: '100%',
    clipPath: "polygon(0 0, 0% 100%, 100% 0)",
    shapeOutside: "polygon(0 0, 0% 100%, 100% 0)",
    [emulatorScreen(theme)]: {
      // height: 40,
      // width: 53,
      // clipPath: "polygon(0 0, 0% 100%, 100% 0)",
      // shapeOutside: "polygon(0 0, 0% 100%, 100% 0)",
    },
    [mobileScreen(theme)]: {
      // height: 43,
      // width: 123,
      // clipPath: "polygon(0 0, 0% 100%, 100% 0)",
      // shapeOutside: "polygon(0 0, 0% 100%, 100% 0)",
    },
  },

  shape8Major: {
    width: 100,
    height: 69,
    overflow: "hidden",
    top: 260.5,
    left: 111,
    position: "absolute",
    zIndex: 3,
    [emulatorScreen(theme)]: {
      width: 65,
      height: 47,
      top: 175.5,
      left: 75,
    },
    [mobileScreen(theme)]: {
      width: 60,
      height: 46,
      top: 176,
      left: 75,
    },
  },

  shape8: {
    height: 68,
    width: 91,
    [emulatorScreen(theme)]: {
      height: 47,
      width: 62,
    },
    [mobileScreen(theme)]: {
      height: 46,
      width: 60,
    },
  },

  shape9Major: {
    width: 94,
    height: 70,
    overflow: "hidden",
    top: 260.5,
    left: 118,
    position: "absolute",
    clipPath: "polygon(100% 0, 100% 100%, 0 100%)",
    shapeOutside: "polygon(100% 0, 100% 100%, 0 100%)",
    zIndex: 3,
    [emulatorScreen(theme)]: {
      width: 63,
      height: 47,
      top: 178,
      left: 77.5,
    },
    [mobileScreen(theme)]: {
      width: 63,
      height: 47,
      top: 177.5,
      left: 78,
    },
  },

  shape9: {
    height: 70,
    width: 94,
    [emulatorScreen(theme)]: {
      height: "97%",
      width: "99.15%",
    },
    [mobileScreen(theme)]: {
      height: "97%",
      width: "99.15%",
    },
  },

  shape10Major: {
    width: 82,
    height: 70,
    overflow: "hidden",
    top: 260.5,
    left: 216,
    position: "absolute",
    zIndex: 3,
    [emulatorScreen(theme)]: {
      width: 58,
      height: 48,
      top: 175.5,
      left: 143,
    },
    [mobileScreen(theme)]: {
      width: 58,
      height: 47,
      top: 176,
      left: 143,
    },
  },

  shape10: {
    height: 70,
    width: 82,
    [emulatorScreen(theme)]: {
      height: 48,
      width: 58,
    },
    [mobileScreen(theme)]: {
      height: 47,
      width: 58,
    },
  },

  shape6Major: {
    width: 81.5,
    height: 61.5,
    overflow: "hidden",
    top: 194.5,
    left: 217,
    position: "absolute",
    zIndex: 3,
    clipPath: "polygon(100% 1px, 0% 100%, 100% 100%)",
    shapeOutside: "polygon(100% 0, 0% 100%, 100% 100%)",
    [emulatorScreen(theme)]: {
      width: 53.5,
      height: 42,
      top: 131,
      left: "54.6%",
    },
    [mobileScreen(theme)]: {
      width: 53.5,
      height: 42,
      top: 130.5,
      left: "54.7%",
    },
  },

  shape6: {
    height: 63,
    width: 82,
    [emulatorScreen(theme)]: {
      height: 42,
      width: 54,
    },
    [mobileScreen(theme)]: {
      height: 42,
      width: 54,
    },
  },

  shape7Major: {
    height: 60.5,
    overflow: "hidden",
    top: 195,
    left: 302,
    position: "absolute",
    zIndex: 3,
    clipPath: "polygon(100% 100%, 0 0, 0 100%)",
    shapeOutside: "polygon(100% 100%, 0 0, 0 100%)",
    [emulatorScreen(theme)]: {
      height: 42,
      top: 131,
      left: "75.35%",
    },
    [mobileScreen(theme)]: {
      height: 41.5,
      top: 131,
      left: "75.35%",
    },
  },

  shape7: {
    height: 60.5,
    width: 81.5,
    [emulatorScreen(theme)]: {
      height: 42,
      width: 55.5,
    },
    [mobileScreen(theme)]: {
      height: 41.5,
      width: 55.5,
    },
  },

  shape11Major: {
    width: 86.5,
    height: 70,
    overflow: "hidden",
    top: 260.5,
    left: 302,
    position: "absolute",
    zIndex: 3,
    [emulatorScreen(theme)]: {
      width: 60,
      height: 48,
      top: 175.5,
      left: "75.3%",
    },
    [mobileScreen(theme)]: {
      width: 60,
      height: 47,
      top: 176,
      left: "75.3%",
    },
  },

  shape11: {
    height: 70,
    width: 87,
    [emulatorScreen(theme)]: {
      height: 48,
      width: "97.4%",
    },
    [mobileScreen(theme)]: {
      height: 47,
      width: "97.4%",
    },
  },

  shape14Major: {
    width: 184.5,
    height: 202,
    overflow: "hidden",
    top: 53,
    left: 305,
    position: "absolute",
    zIndex: 2,
    [emulatorScreen(theme)]: {
      width: 124,
      height: 142,
      clipPath: "polygon(0px 69%, 102% 0%, 100% 100%, 46% 100%)",
      top: 30.55,
      left: 206,
    },
    [mobileScreen(theme)]: {
      width: 123.5,
      height: 142,
      top: 31,
      left: 206,
    },
  },

  shape14: {
    height: 202,
    width: 184.5,
    [emulatorScreen(theme)]: {
      height: 143,
      width: 129.5,
    },
    [mobileScreen(theme)]: {
      height: 143,
      width: 129.5,
    },
  },

  shape12Major: {
    width: 90.5,
    height: 68.5,
    overflow: "hidden",
    top: 262,
    left: 392,
    position: "absolute",
    zIndex: 2,
    clipPath: "polygon(0 0, 0% 100%, 100% 100%)",
    shapeOutside: "polygon(0 0, 0% 100%, 100% 100%)",
    [emulatorScreen(theme)]: {
      width: 63.5,
      height: 48,
      top: 175.5,
      left: 264,
    },
    [mobileScreen(theme)]: {
      width: 63.5,
      height: 47,
      top: 176,
      left: 264,
    },
  },

  shape12: {
    height: 68.5,
    width: 91.3,
    [emulatorScreen(theme)]: {
      height: 48,
      width: "98%",
    },
    [mobileScreen(theme)]: {
      height: 47,
      width: "98%",
    },
  },

  shape13Major: {
    width: 89,
    height: 67,
    overflow: "hidden",
    top: 260.5,
    left: 400,
    position: "absolute",
    zIndex: 2,
    clipPath: "polygon(100% 0, 0 0, 100% 100%)",
    shapeOutside: "polygon(100% 0, 0 0, 100% 100%)",
    [emulatorScreen(theme)]: {
      width: 60,
      height: 45,
      top: 176,
      left: 270,
    },
    [mobileScreen(theme)]: {
      width: 59,
      height: 44,
      top: 176,
      left: 271,
    },
  },

  shape13: {
    height: 67,
    width: 89,
    [emulatorScreen(theme)]: {
      height: 45,
      width: 60,
    },
    [mobileScreen(theme)]: {
      height: 43.5,
      width: 59,
    },
  },
});
export default styles;
